import { createTypes } from "reduxsauce";

export default createTypes(
    `
    FETCH_CAROUSEL_STORE_INIT
    FETCH_CAROUSEL_STORE_DATA_SUCCESS
    FETCH_CAROUSEL_STORE_DATA_FAILURE
`,
    {
        prefix: "carouselStore/"
    }
);
